import * as THREE from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls"

const getType = filename => typeof(filename) != 'undefined' && filename != null? filename.split( '.' ).pop().toLowerCase() : 'fbx';

export default class ModelViewer {
    constructor(width, height, isControlled = false, backgroundColor = 0xD7D8D8) {
        this.scene = new THREE.Scene();
        this.scene.background = new THREE.Color(backgroundColor);
        this.renderer = new THREE.WebGLRenderer({alpha: true, preserveDrawingBuffer: true });
        this.camera = new THREE.PerspectiveCamera(50, 1, 0.1, 2000);
        var light = new THREE.HemisphereLight(0xffffbb, 0x080820, 1);
        this.renderer.setSize(width, height);
        this.renderer.domElement.className = 'model-canvas';
        this.scene.add(light);
        this.model = null;
        this.isControlled = isControlled;
        this.controls = isControlled ? new OrbitControls(this.camera, this.renderer.domElement) : null;
        this.type = 'fbx';
    }

    loadFile(filePath, filename) {
        this.type = getType(filename);
        var loader = undefined;
        switch (this.type) {
            case 'gltf':
            case 'glb':
                loader = new GLTFLoader();
                break;
            case 'fbx':
            default:
                loader = new FBXLoader();
                break;
        }
        
        loader.load(filePath, function(model) {
          if (this.type === 'gltf' || this.type === 'glb')
            model = model.scene;
          this.scene.add(model);
          this.fitCameraToObject(this.camera, model)
          this.renderer.render(this.scene, this.camera);
          this.model = model;
          if (this.isControlled){
            this.controls.update();
            this.controls.addEventListener('change', function() {this.renderer.render(this.scene, this.camera)}.bind(this))
          }
        }.bind(this), undefined, function(error) {
          throw error;
        } );
        return this.renderer.domElement;
    }

    fitCameraToObject(camera, object, offset, controls) {
        const boundingBox = new THREE.Box3();
          boundingBox.setFromObject(object);
            var center = new THREE.Vector3();
          const centerm = boundingBox.getCenter(center);
          var size = new THREE.Vector3();
          const sizem = boundingBox.getSize(size);
          camera.position.set( size.x, size.y, size.z );

          camera.lookAt(center);        
      }

    getImage() {
        var imgData, imgNode;
        try {
            var strMime = "image/jpeg";
            imgData = this.renderer.domElement.toDataURL(strMime);
            return imgData;
        } catch (e) {
            console.log(e);
            return;
        }
    }

    getSize() {
        if (!this.model) return null;
        const boundingBox = new THREE.Box3();
        boundingBox.setFromObject(this.model);
        var size = new THREE.Vector3();
        const sizem = boundingBox.getSize(size);
        return size;
    }

    getCenter() {
        if (!this.model) return null;
        const boundingBox = new THREE.Box3();
        boundingBox.setFromObject(this.model);
          var center = new THREE.Vector3();
        const centerm = boundingBox.getCenter(center);
        return center;
    }
}